import { render, staticRenderFns } from "./PageHeaderNew.vue?vue&type=template&id=18e9c425&scoped=true&"
import script from "./PageHeaderNew.vue?vue&type=script&lang=js&"
export * from "./PageHeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderNew.vue?vue&type=style&index=0&id=18e9c425&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9c425",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LangSwitcher: require('/web/components/helpers/LangSwitcher.vue').default})
